export const HEADER_KEY_CONTENT_TYPE = 'Content-Type';
export const HEADER_KEY_AUTHORIZATION = 'Authorization';
export const HEADER_KEY_X_API_KEY = 'x-api-key';

export const HEADER_VALUE_CONTENT_TYPE_APPLICATION_JSON = 'application/json';
export const HEADER_VALUE_CONTENT_TYPE_TEXT_PLAIN = 'text/plain';
